import styled from 'styled-components';

export default styled.div`
  /* To allow for 100% height children */
  position: absolute;

  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  display: flex;
  flex-direction: column;

  > h2 {
    flex: 0 0 auto;

    color: ${props => props.theme.palette.primary.main};
    font-size: 2.4rem;
    font-weight: 400;
  }

  > .selection {
    flex: 0 0 auto;

    padding: 1rem 0 2rem;

    > .phones {
      padding-top: 2rem;

      display: flex;

      > .phone {
        flex: 0 0 50%;

        &:first-of-type {
          padding-right: 1.5rem;
        }

        &:not(:first-of-type):not(:last-of-type) {
          padding: 0 1.5rem;
        }

        &:last-of-type {
          padding-left: 1.5rem;
        }
      }
    }
  }

  > .slider {
    flex: 1 1 auto;
  }
`;
